module.exports = __webpack_public_path__ + "img/60b49cc874d4145b69b005fb8c3fe414.svg";